import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NotificationModel } from 'src/app/models/notification.model';
import { NotificationsModel } from 'src/app/models/notifications.model';

import { ActiveService } from '../../active-service';

@Injectable()
export class NotificationService extends ActiveService {
    constructor(
        public http: HttpClient,
        public store: Store
    ) {
        super(http, store);
    }

    getNotifications(limit, orgId: string): Observable<any> {
        return this.get(`notifications/organization/${orgId}?page=0&limit=${limit}`).pipe(
            map((resp) => {
                return new NotificationsModel(resp.models);
            }),
            catchError((error) => {
                throw error.error.models;
            })
        );
    }

    getNotificationUnReadCount(orgId: string): Observable<any> {
        return this.get(`notifications/count/organization/${orgId}`).pipe(
            map((resp) => {
                return resp.models;
            }),
            catchError((error) => {
                throw error.error.models;
            })
        );
    }

    readNotification(notificationIdArr, orgId: string): Observable<NotificationModel[]> {
        return this.put(`notifications/read/organization/${orgId}`, {
            notification_id_array: notificationIdArr,
        }).pipe(
            map((resp) => {
                return resp.models.notification;
            }),
            catchError((error) => {
                throw error?.error?.models;
            })
        );
    }

    resetNotification(organizationId: string): Observable<any> {
        return this.put(`notifications/resetcounter/organization/${organizationId}`, {
            notification: true,
        }).pipe(
            map((resp) => {
                return resp.models;
            }),
            catchError((error) => {
                throw error.error.models;
            })
        );
    }
}
